"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const moonUILabelVariantsPro = cva(
  "text-sm font-medium leading-none text-gray-900 dark:text-gray-200 peer-disabled:cursor-not-allowed peer-disabled:opacity-70 dark:peer-disabled:opacity-60 transition-colors duration-200"
)

const MoonUILabelPro = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof moonUILabelVariantsPro>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(moonUILabelVariantsPro(), className)}
    {...props}
  />
))
MoonUILabelPro.displayName = LabelPrimitive.Root.displayName

export { MoonUILabelPro  };

// Backward compatibility exports
export { MoonUILabelPro as Label }